import React, { useState } from 'react';
import { Bell, Shield, Menu, X, ChevronDown, LogOut, User, Settings } from 'lucide-react';
import { Usuario } from '../../types';

interface HeaderProps {
  usuario: Usuario;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ usuario, onLogout }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <header className="bg-cyber-dark-blue/80 backdrop-blur-md border-b border-cyber-blue/30 py-3 px-4 sticky top-0 z-10">
      <div className="flex items-center justify-between">
        {/* Logo y título */}
        <div className="flex items-center">
          <div className="flex items-center text-cyber-blue mr-2">
            <Shield className="h-7 w-7" />
          </div>
          <div>
            <h1 className="text-white text-xl font-bold">CyberShield</h1>
            <p className="text-cyber-light text-xs">Plataforma Avanzada de Seguridad</p>
          </div>
        </div>

        {/* Menú de navegación - Escritorio */}
        <nav className="hidden md:flex items-center space-x-6">
          <a href="#" className="text-white hover:text-cyber-blue transition-colors">Panel Principal</a>
          <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Monitoreo</a>
          <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Credenciales</a>
          <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Informes</a>
        </nav>

        {/* Controles de usuario */}
        <div className="flex items-center">
          {/* Botón de notificaciones */}
          <button className="relative p-2 text-cyber-light hover:text-cyber-blue transition-colors mr-2">
            <Bell className="h-5 w-5" />
            <span className="absolute top-1 right-1 h-2 w-2 bg-cyber-alert rounded-full"></span>
          </button>

          {/* Perfil de usuario */}
          <div className="relative">
            <button 
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-cyber-gray/20 transition-colors"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="flex items-center justify-center h-8 w-8 rounded-full bg-cyber-blue text-white font-medium">
                {usuario.nombre.charAt(0)}
              </div>
              <div className="hidden sm:block text-left">
                <p className="text-sm text-white">{usuario.nombre}</p>
                <p className="text-xs text-cyber-light">{usuario.rol}</p>
              </div>
              <ChevronDown className="h-4 w-4 text-cyber-light" />
            </button>

            {/* Menú desplegable de usuario */}
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-cyber-dark-blue/95 backdrop-blur-md border border-cyber-blue/30 rounded-lg shadow-lg z-20">
                <div className="p-3 border-b border-cyber-gray/30">
                  <p className="text-sm text-white font-medium">{usuario.nombre}</p>
                  <p className="text-xs text-cyber-light">{usuario.email}</p>
                </div>
                <div className="p-1">
                  <a 
                    href="#" 
                    className="flex items-center px-3 py-2 text-sm text-cyber-light hover:bg-cyber-gray/20 rounded-md transition-colors"
                  >
                    <User className="h-4 w-4 mr-2" />
                    Perfil
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center px-3 py-2 text-sm text-cyber-light hover:bg-cyber-gray/20 rounded-md transition-colors"
                  >
                    <Settings className="h-4 w-4 mr-2" />
                    Configuración
                  </a>
                  <button 
                    onClick={onLogout}
                    className="flex w-full items-center px-3 py-2 text-sm text-cyber-alert hover:bg-cyber-gray/20 rounded-md transition-colors"
                  >
                    <LogOut className="h-4 w-4 mr-2" />
                    Cerrar Sesión
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Botón de menú móvil */}
          <button 
            className="ml-4 md:hidden text-cyber-light hover:text-cyber-blue transition-colors"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            {showMobileMenu ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Menú móvil desplegable */}
      {showMobileMenu && (
        <nav className="md:hidden mt-3 pt-3 border-t border-cyber-gray/30">
          <div className="flex flex-col space-y-3">
            <a href="#" className="text-white hover:text-cyber-blue transition-colors">Panel Principal</a>
            <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Monitoreo</a>
            <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Credenciales</a>
            <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors">Informes</a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;